"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _axiosInterceptorsLoader = _interopRequireDefault(require("./axios-interceptors-loader"));

var _axiosInterceptWixResult = _interopRequireDefault(require("./axios-intercept-wix-result"));

var _axiosInterceptBaseurl = _interopRequireDefault(require("./axios-intercept-baseurl"));

var _axiosInterceptMultilingual = _interopRequireDefault(require("./axios-intercept-multilingual"));

var _axiosInterceptArtifactid = _interopRequireDefault(require("./axios-intercept-artifactid"));

var _axiosInterceptSiteRevision = _interopRequireDefault(require("./axios-intercept-site-revision"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(axios, _ref) {
  var req = _ref.req,
      adapter = _ref.adapter,
      baseURL = _ref.baseURL,
      lang = _ref.lang,
      locale = _ref.locale,
      isPrimaryLanguage = _ref.isPrimaryLanguage,
      siteInstance = _ref.siteInstance,
      _ref$loadInterceptors = _ref.loadInterceptors,
      loadInterceptors = _ref$loadInterceptors === void 0 ? true : _ref$loadInterceptors,
      wixCodeApi = _ref.wixCodeApi,
      _ref$shouldAddArtifac = _ref.shouldAddArtifactIdOverride,
      shouldAddArtifactIdOverride = _ref$shouldAddArtifac === void 0 ? false : _ref$shouldAddArtifac;
  var config = {
    baseURL: baseURL || axios.defaults.baseURL,
    adapter: adapter,
    lang: lang,
    locale: locale,
    isPrimaryLanguage: isPrimaryLanguage,
    siteInstance: siteInstance
  };

  if (req) {
    config.headers = req.headers;
  }

  var instance = axios.create(config);
  instance.unregisterWixInterceptors = _axiosInterceptorsLoader["default"].loadIfNeeded(instance, {
    shouldLoadInterceptors: loadInterceptors,
    interceptors: [_axiosInterceptWixResult["default"], _axiosInterceptBaseurl["default"], _axiosInterceptMultilingual["default"].getInterceptor({
      lang: lang,
      siteInstance: siteInstance,
      locale: locale,
      isPrimaryLanguage: isPrimaryLanguage
    }), _axiosInterceptArtifactid["default"].getInterceptor({
      shouldAddArtifactIdOverride: shouldAddArtifactIdOverride
    }), _axiosInterceptSiteRevision["default"].getInterceptor({
      wixCodeApi: wixCodeApi
    })]
  });
  return instance;
};

exports["default"] = _default;